import React from 'react'

const MailIcon = () => (
  <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.9688 0.5H7.03125C3.148 0.5 0 3.648 0 7.53125V23.4688C0 27.352 3.148 30.5 7.03125 30.5H22.9688C26.852 30.5 30 27.352 30 23.4688V7.53125C30 3.648 26.852 0.5 22.9688 0.5Z"
      fill="white"
    />
    <rect x="6.5" y="9.5" width="17" height="12" rx="2" stroke="black" strokeWidth="2" />
    <path
      d="M6.5 10.5L15 17L23.5 10.5"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default MailIcon
